import { Card as MuiCard, CardContent, CardActions, styled, Chip, Tooltip, Box } from "@mui/material";
import { Attachment, Delete } from "@mui/icons-material";
import { titleize } from "inflection";
import { useMutation } from "@apollo/client/react";
import { GetPersonalNotesQuery, DestroyNotesDocument } from "@/graphql/generated/graphql";
import { arrayLength } from "@/utils/helperFunctions";
import { displayNotification } from "@/utils/notifications";

interface NoteCardProps {
  note: NonNullable<GetPersonalNotesQuery['getPersonalNotes']>[0];
  onClick: () => void;
}


const Card = styled(MuiCard)({
  "&:not(:last-of-type)": {
    marginBottom: 10,
  }
});

const StyledBox = styled(Box)(() => ({
  marginBottom: 5,
  display: "flex",
  alignItems: "center",
  ".MuiChip-root:not(:last-of-type)": {
    marginRight: 5
  }
}));
const NoteCard: React.FC<NoteCardProps> = ({ note, onClick }) => {
  const [destroyNotes] = useMutation(DestroyNotesDocument, {
    onCompleted: () => {
      displayNotification({ type: "success", text: "Note deleted successfully" });
    },
    refetchQueries: ["getPersonalNotes"]
  });

  return (
    <Card
      variant="outlined"
      onClick={onClick}
      sx={{ marginX: 2, marginBottom: 1, cursor: 'pointer', width: '100%' }}
    >
      <CardActions sx={{ justifyContent: "space-between" }}>
        <StyledBox>
          <Chip size="small" variant="outlined" label={titleize(note.notesType)} sx={{ fontSize: 10, mr: 1 }} />
          {arrayLength(note.attachments) > 0 &&
            <Tooltip title='Has attachments associated'>
              <Attachment fontSize='small' />
            </Tooltip>
          }
        </StyledBox>
        <Tooltip title="Delete Note">
          <Delete fontSize="small" sx={{ color: "error.main" }} onClick={(e) => {
            e.stopPropagation();
            destroyNotes({ variables: { id: note.id } });
          }} />
        </Tooltip>
      </CardActions>
      <Tooltip title="click to edit/expand">
        <CardContent sx={{ p: 1, pb: 0, maxHeight: 150, overflowY: "scroll", fontSize: '0.8rem' }}>
          {note.description}
        </CardContent>
      </Tooltip>


    </Card>
  )
}

export default NoteCard;
